let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("h2MrD"), load("bYT2S"), load("kfXhT"), load("2Lfdl"), load("6BhXI")]).then(() => parcelRequire('8SAZe'));